<template>
  <div class="portfolio">
    <div
      class="sidebar"
      v-if="showSidebar"
      :style="{width: sidebarWidth}"
    />
    <NativeScrollableContent
      :id="scrollId"
      :height="`calc(100vh - ${headerHeight})`"
      :max-height="`calc(100vh - ${headerHeight})`"
      @onScrollY="updateScrollValue"
    >
      <div class="portfolio-content">
        <div class="search-placeholder">
          <FixedHideable
            direction="up"
            :transition-ms="300"
            :hide="hideSearch"
            :top="headerHeight"
            right="0"
            :left="showSidebar ? sidebarWidth : '0'"
          >
            <div class="search-container">
              <PortfolioSearch
                class="search"
                v-model="search"
                :input-event-debounce-ms="300"
                :placeholder="$t('globals.search')"
              />
            </div>
          </FixedHideable>
        </div>
        <div>
          <PortfolioSection
            v-for="portfolio in portfolios"
            :key="portfolio.id"
            :id="portfolio.id"
            :name="portfolio.name || $t('views.portfolio.personal.title')"
            :search-input="search"
          />
        </div>
      </div>
    </NativeScrollableContent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';
import NativeScrollableContent from '@/shared/components/scrollbar/NativeScrollableContent';
import FixedHideable from '@/shared/components/hideable/FixedHideable';
import PortfolioSearch from '@/components/pages/Portfolio/PortfolioSearch';
import FocusedElementWatcher from '@/shared/components/scrollbar/FocusedElementWatcher';
import PortfolioSection from './Portfolio/PortfolioSection';

export default {
  name: 'PortfolioV2',
  components: {
    NativeScrollableContent,
    PortfolioSection,
    PortfolioSearch,
    FixedHideable,
  },
  props: {
    searchEnabled: {
      type: Boolean,
      default: false,
    },
    treeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollId: 'portfolio-scroll',
      sidebarWidth: '300px',
      headerHeight: '48px',
      documents: {},
      search: '',
      lastScrollOffset: 0,
      hideSearch: false,
    };
  },
  computed: {
    ...mapGetters({
      portfolios: types.portfolioV2.getters.portfolios,
    }),
    showSidebar() {
      return this.treeEnabled && this.$vuetify.breakpoint.mdAndUp;
    },
  },
  methods: {
    ...mapActions({
      fetchPortfolios: types.portfolioV2.actions.fetchPortfolios,
    }),
    updateScrollValue() {
      const watcher = new FocusedElementWatcher(this.scrollId);
      const scrollOffset = watcher.getScrollOffset();

      this.hideSearch = scrollOffset > this.lastScrollOffset;
      this.lastScrollOffset = scrollOffset;
    },
  },
  created() {
    this.fetchPortfolios();
  },
};
</script>

<style scoped>
.portfolio {
  width: 100%;
  display: flex;
}

.portfolio-content {
  width: 100%;
  max-width: 1800px;
  margin: auto;
  padding-bottom: 24px;
}

.search-placeholder {
  width: 100%;
  height: 80px;
}

.search-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.search {
  width: 100%;
  max-width: 600px;
  padding: 16px;
}

.sidebar {
  flex-shrink: 0;
  padding-right: 32px;
}
</style>
